var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, computed, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
import { strip } from '../../../utils/serializr/schema/inner/strip';
import { VideoVid } from './modules/VideoVid';
import { runtime } from '../../runtime/Runtime';
export class AttachedVideo extends AttachedContent {
    type = 'video';
    shouldPlayTrigger = false;
    currentPositionInSeconds = 0;
    startDate;
    endDate;
    isPlaying = false;
    hasEnded = false;
    hasError = false;
    videoHandler;
    reactPlayer;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get videoVid() {
        return new VideoVid(this);
    }
    get shouldPlay() {
        return this.canPlay && this.shouldPlayTrigger && !this.isStopMarkHindering;
    }
    get canPlay() {
        if (!runtime.availablePackages.Defer)
            return false;
        return this.context.app.media.mediaStarter.isAutoPlayPossible;
    }
    get vid() {
        if (!this.trait.value) {
            const vidTrait = this.createNewVidTrait();
            runtime.runtimeScheduler.addToNextStateChange(() => (this.trait.value = vidTrait.value));
            return vidTrait.value;
        }
        return this.trait.value;
    }
    get medFile() {
        return this.vid;
    }
    createNewVidTrait() {
        return runtime.class.Trait.fromSerialized({
            parent: this.trait,
            key: 'vid',
            value: { type: 'vid' },
        });
    }
    get isStopMarkHindering() {
        return !!this.activesOf.videoStopMark.find(at => this.currentPositionInSeconds * 1000 > at.trait.value);
    }
    get remainingPlaytimeInSeconds() {
        if (!this.isPlaying)
            return 0;
        return Math.max(0, this.vid.durationInSeconds - this.currentPositionInSeconds);
    }
    get remainingTimeMarks() {
        return this.vid.timeMarks.filter(timeMark => !this.context.app.asking.askingMarks.answerMarkNames.includes(timeMark.markName));
    }
    checkIfReachedTimeMarks() {
        for (const timeMark of this.remainingTimeMarks) {
            if (this.currentPositionInSeconds * 1000 >= timeMark.markTime) {
                this.context.app.asking.askingMarks.addMark(timeMark.markName);
            }
        }
    }
    static get stripInfo() {
        return {
            extends: AttachedContent.stripInfo,
            props: {
                video: strip((at) => at.vid && at.vid.serialized),
            },
        };
    }
}
__decorate([
    observable
], AttachedVideo.prototype, "shouldPlayTrigger", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "currentPositionInSeconds", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "startDate", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "endDate", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "isPlaying", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "hasEnded", void 0);
__decorate([
    observable
], AttachedVideo.prototype, "hasError", void 0);
__decorate([
    observable.ref
], AttachedVideo.prototype, "videoHandler", void 0);
__decorate([
    memoize
], AttachedVideo.prototype, "videoVid", null);
__decorate([
    computed
], AttachedVideo.prototype, "shouldPlay", null);
__decorate([
    computed
], AttachedVideo.prototype, "vid", null);
__decorate([
    action.bound
], AttachedVideo.prototype, "createNewVidTrait", null);
__decorate([
    computed
], AttachedVideo.prototype, "isStopMarkHindering", null);
__decorate([
    computed
], AttachedVideo.prototype, "remainingPlaytimeInSeconds", null);
__decorate([
    computed
], AttachedVideo.prototype, "remainingTimeMarks", null);
__decorate([
    action.bound
], AttachedVideo.prototype, "checkIfReachedTimeMarks", null);
__decorate([
    memoize
], AttachedVideo, "stripInfo", null);
